import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { APP_PATHS } from '../config/app-paths';
import { map } from 'rxjs';
import { UserApi } from '../../shared/services/api/user.api';
import { MessageService } from 'primeng/api';
import { Beneficjent } from '../../shared/models/beneficjent';
import { ToastSeverity } from '../../shared/enums/toast-severity.enum';

export const DataVerifiedGuard: CanActivateFn = (_, state) => {
  const userApi = inject(UserApi);
  const router = inject(Router);
  const messageService = inject(MessageService);

  return userApi.getUser$().pipe(
    map((beneficjent: Beneficjent) => {
      if (!beneficjent.zweryfikowaneDane) {
        messageService.add({
          severity: ToastSeverity.ERROR,
          summary: 'Prosimy o zweryfikowanie aktualności danych konta.',
        });

        return router.createUrlTree([
          `${APP_PATHS.userSettings.root}/${APP_PATHS.userSettings.editUser}`,
        ]);
      }

      return true;
    }),
  );
};
